type IconProps = {
  src: string;
  size?: number;
  color?: string;
};

export function TintIcon({ src, size = 24, color = "#fff" }: IconProps) {
  return (
    <span
      style={{
        width: size,
        height: size,
        display: "inline-block",
        backgroundColor: color,
        WebkitMaskImage: `url(${src})`,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
        maskImage: `url(${src})`,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        objectFit: "contain",
      }}
    />
  );
}
